export default __webpack_public_path__ + "static/media/hcvit.3a78db04.png";